import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stepper-register-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex align-center justify-center ma-xl-16 ma-lg-10 ma-0 registration-container" }
const _hoisted_4 = { class: "d-flex flex-column text-center align-center header-step-number" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "step-divider" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "step-divider" }, null, -1)
const _hoisted_7 = { class: "d-flex flex-column text-center align-center header-step-number" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "step-divider" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "step-divider" }, null, -1)
const _hoisted_10 = { class: "d-flex flex-column text-center align-center header-step-number" }
const _hoisted_11 = { class: "d-flex flex-column ma-xl-16 ma-lg-10 ma-4 justify-center align-center" }
const _hoisted_12 = {
  key: 0,
  class: "my-6",
  color: "primary",
  size: "100"
}
const _hoisted_13 = {
  key: 1,
  class: "my-6"
}
const _hoisted_14 = {
  key: 2,
  class: "d-flex flex-column ma-6 justify-center align-center"
}
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:ambassadeurs@aveine.paris" }, "ambassadeurs@aveine.paris", -1)
const _hoisted_18 = {
  key: 3,
  class: "d-flex flex-column ma-6 px-xl-16 justify-center align-center"
}
const _hoisted_19 = { class: "text-center mx-xl-16 mx-lg-10 mb-8" }
const _hoisted_20 = { class: "text-center mx-xl-16 mx-lg-10 mb-8" }
const _hoisted_21 = { href: "/" }
const _hoisted_22 = {
  key: 4,
  class: "d-flex flex-column ma-6 px-xl-16 justify-center align-center"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 0,
  class: "text-center mx-xl-16 mx-lg-10 mb-8"
}
const _hoisted_25 = {
  key: 1,
  class: "d-flex justify-center"
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "d-flex flex-column" }
const _hoisted_28 = { class: "d-flex flex-row align-center contract" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "d-flex mt-3 justify-start" }
const _hoisted_31 = { class: "d-flex justify-space-between" }
const _hoisted_32 = { class: "d-flex flex-column ma-xl-6" }
const _hoisted_33 = { class: "ma-8 d-flex flex-column justify-center align-center step-content" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "d-flex flex-column justify-center" }
const _hoisted_36 = {
  key: 1,
  class: "d-flex justify-center align-center mt-16"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_stepper_step = _resolveComponent("v-stepper-step")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_AveineLogin = _resolveComponent("AveineLogin")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_AveineAmbassadorForm = _resolveComponent("AveineAmbassadorForm")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createBlock(_component_v_stepper, {
              class: "stepper-container",
              modelValue: _ctx.currentStep,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentStep) = $event)),
              key: _ctx.currentStep
            }, {
              default: _withCtx(() => [
                (!_ctx.errorHasOccured)
                  ? (_openBlock(), _createBlock(_component_v_stepper_header, {
                      key: 0,
                      class: "pa-10 px-xl-16 px-lg-14 px-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['step-number', _ctx.currentStep == 1 ? 'active' : ''])
                          }, "1", 2),
                          _createVNode(_component_v_stepper_step, {
                            complete: _ctx.currentStep > 1,
                            value: 1,
                            step: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.login")), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["complete"])
                        ]),
                        _hoisted_5,
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['step-number', _ctx.currentStep == 2 ? 'active' : ''])
                          }, "2", 2),
                          _createVNode(_component_v_stepper_step, {
                            complete: _ctx.currentStep > 2 || _ctx.tosAlreadySigned,
                            value: 2,
                            step: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.tos")), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["complete"])
                        ]),
                        _hoisted_8,
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['step-number', _ctx.currentStep == 3 ? 'active' : ''])
                          }, "3", 2),
                          _createVNode(_component_v_stepper_step, {
                            complete: _ctx.currentStep > 3 || (_ctx.ambassador && _ctx.ambassador.name) ? true : false,
                            value: 3,
                            step: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.accountInfo")), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["complete"])
                        ]),
                        _createVNode(_component_v_stepper_step, {
                          complete: _ctx.currentStep > 4,
                          value: 4,
                          step: 4
                        }, null, 8, ["complete"])
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.currentStep == 1)
                  ? (_openBlock(), _createBlock(_component_v_stepper_item, {
                      key: 1,
                      value: 1
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          (!_ctx.roleAlreadyAssigned && !_ctx.errorHasOccured)
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_12, _toDisplayString(_ctx.$t('aveine-space.onBoarding.welcome')), 1))
                            : (_openBlock(), _createElementBlock("h1", _hoisted_13, [
                                _createVNode(_component_v_icon, {
                                  color: "secondary",
                                  size: "100"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-alert-circle-outline")
                                  ], undefined, true),
                                  _: 1
                                })
                              ])),
                          (_ctx.errorHasOccured)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("h3", _hoisted_15, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('aveine-space.errors.registrationError')), 1),
                                  _hoisted_16,
                                  _hoisted_17
                                ])
                              ]))
                            : (_ctx.roleAlreadyAssigned)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$t('aveine-space.errors.roleAlreadyAssigned')), 1),
                                  _createElementVNode("span", _hoisted_20, [
                                    _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t("aveine-space.onBoarding.backToIndex")), 1)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("h4", {
                                    innerHTML: _ctx.$t('aveine-space.onBoarding.introText'),
                                    class: "text-center mx-xl-16 mx-lg-10 mb-8"
                                  }, null, 8, _hoisted_23),
                                  (!_ctx.$auth.isAuthenticated)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.userNotLoggedIn")) + " ", 1),
                                        _createVNode(_component_AveineLogin, {
                                          class: "my-5",
                                          signingUp: true
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.roleAlreadyAssigned && !_ctx.errorHasOccured && _ctx.$auth.isAuthenticated)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createVNode(_component_v_btn, {
                                          disabled: !_ctx.$auth.isAuthenticated,
                                          class: "ma-6",
                                          color: "primary",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentStep += 1))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.start")), 1)
                                          ], undefined, true),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_list_item, { class: "d-flex justify-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        modelValue: _ctx.$i18n.locale,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
                                        items: ['FR', 'EN'],
                                        "single-line": ""
                                      }, null, 8, ["modelValue"])
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  (_ctx.$auth.isAuthenticated)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                                        (_openBlock(), _createBlock(_component_AveineLogin, {
                                          key: _ctx.$auth.isLoading
                                        }))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                        ])
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.currentStep == 2)
                  ? (_openBlock(), _createBlock(_component_v_stepper_item, {
                      key: 2,
                      value: 2
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("iframe", {
                              id: "contract-iframe",
                              src: _ctx.latestTos.name + '#page=1&zoom=80'
                            }, null, 8, _hoisted_29)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.agreedToTos,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agreedToTos) = $event)),
                              label: _ctx.$t('aveine-space.onBoarding.agreeTos')
                            }, null, 8, ["modelValue", "label"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_v_btn, {
                            raised: "",
                            variant: "text",
                            class: "ma-6",
                            color: "primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentStep -= 1))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.back")), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            disabled: !_ctx.agreedToTos,
                            class: "ma-6 justify-end",
                            color: "primary",
                            onClick: _ctx.agreeTos
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.next")), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ])
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.currentStep == 3 && _ctx.$auth.isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_v_stepper_item, {
                      key: 3,
                      value: 3
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_AveineAmbassadorForm, {
                            APIbaseURL: _ctx.APIbaseURL,
                            ambassador: _ctx.ambassador,
                            callback: _ctx.savedInformations
                          }, null, 8, ["APIbaseURL", "ambassador", "callback"])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_btn, {
                            raised: "",
                            variant: "text",
                            class: "ma-6",
                            color: "primary",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentStep -= 1))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.back")), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ])
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.currentStep == 4 && _ctx.$auth.isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_v_stepper_item, {
                      key: 4,
                      value: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_v_icon, {
                            size: "64",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-check-circle")
                            ], undefined, true),
                            _: 1
                          }),
                          _createElementVNode("h4", _hoisted_34, _toDisplayString(_ctx.$t("aveine-space.onBoarding.signInSuccess")), 1),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_v_btn, {
                              raised: "",
                              variant: "text",
                              class: "ma-6",
                              color: "primary",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goHome()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("aveine-space.onBoarding.backToIndex")), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ])
                        ])
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            }, 8, ["modelValue"]))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: 100,
            width: 10,
            color: "secondary"
          })
        ]))
  ]))
}